import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Button } from '@mui/material'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// import Swal from "sweetalert2";
import appConfig from "../../config/appConfig";
import * as menuActions from '../../store/actions/breadcrumb';
import '../../style/common.css';
import * as Styled from '../../components/styled-components/Styled-Components';
import RadioButtonGroup from '../../components/RadioButtonGroup';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BusinessUnitLocationMapping from './BusinessUnitLocationMapping';
import { useForm, Controller } from 'react-hook-form';
import {  createUserWithEmailAndPassword, updateCurrentUser, updatePassword  } from 'firebase/auth';
import { useTranslation } from 'react-i18next';

import {auth} from '../../config/firebase-config'

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const ViewUser = ({setBreadcrumb}) => {
    const langs = {
        "en": "English",
        "gr": "German",
        "sp_mex": "Spanish (Mexico)",
        "sp_sp": "Spanish (Spain)",
        "sl": "Slovakia",
        "ch": "Chinese",
        "pr": "Portuguese"
      };
    const { t } =  useTranslation('common');
    const params = useLocation();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, control } = useForm();

    const [isAdminUser, setIsAdminUser] = useState("");
    const [isadminUserErr, setAdminUserErr] = useState("");
    const [isActive, setIsActive] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const [userDetails, setUserDetals] = useState({});
    const [apiError, setAPIError] = useState("")
    const [businessOption, setBusinessOption] = useState([])

        useEffect(()=>{
            if(params.state?.user){
                setUserDetals(params.state?.user)
                const isAdmin = params.state?.user?.roleId === 201 ? "Yes" : "No";
                setIsAdminUser(isAdmin)
                const arr   = ["All"]
                const businessUnits = params?.state?.user?.locationData?.map(item => item?.businessUnitName);

                if (businessUnits) {
                  arr.push(...businessUnits?.flat());
                }
                setBusinessOption(arr)
            }
        },[params])

    useEffect(() => {
        const subMenuData = {
            name: t("User Management"),
            route: "/user-management",
            subRoutes: "view-user",
            subRoutesLabel: t("View"),
            isSubMenu: true
        }

        setBreadcrumb(subMenuData)
      }, []);

      const handleFormSubmit = (data) => {
        
        const errorKeys = Object.keys(errors)
        if(errorKeys.length === 0){
            sendFormValues(data);
        }
    }
    const generatePassword = () => {
        let charset = "";
        let newPassword = "";
        const passwordLength = 12;
 
        charset += "!@#$%^&*()";
        charset += "0123456789";
        charset += "abcdefghijklmnopqrstuvwxyz";
         charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
 
        for (let i = 0; i < passwordLength; i++) {
            newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        return newPassword
    };

    const sendFormValues = (formData) => {
        const data = {
                "email": formData?.email,
                "password": generatePassword(),
                "firstName": formData?.firstname,
                "middleName": formData?.miiddlename,
                "lastName": formData?.lastname,
                "isAdmin": formData?.isAdminUser === "Yes" ? true : false,
                "isActive": formData?.isActive === "Yes" ? true : false,
                "locationIdList": selectedItems
              }
             addUser(data)
    }

    const addUser = async (data) => {
      
       try{
        const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);
        // createUserAPI(data);
       }catch(e){
        if(e.code === "auth/email-already-in-use"){
            setAPIError(t("Email Id already exist"))
        }else{
            setAPIError(t("Something went wrong"))
        }
       }
    }

    const updateUserPassword = async() =>{
           try{
            const updateDetails =  await updatePassword(auth.currentUser,'Password@123')
           }catch(e){
                console.log("error",e)
           }

    }

    const filterData = {
        status: 200,
        data : userDetails?.locationData || []
    }

    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("User Management")}</b></h1>
                </Grid>
            </Grid>
          
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Email ID")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('email', { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i})}
                                margin="normal"
                                id="email"
                                sx={textboxCss}
                                value={userDetails?.email}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "email" }}
                            />
                        </div>
                        {errors?.email?.type === "required" && <span style={ErrorStyle}>{t("Please enter email id")}</span>}
                        {errors?.email?.type === "pattern" && (<span style={ErrorStyle}>{t("Please enter valid email id")}</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={4.1} xl={4.1} lg={4.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("First Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('firstname', { required: true, pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="firstname"
                                sx={textboxCss}
                                value={userDetails?.firstName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "first name" }}
                            />
                        </div>
                        {errors?.firstname?.type === "required" && <span style={ErrorStyle}>Please enter first name.</span>}
                        {errors?.firstname?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                    </Grid>
                    <Grid item md={2} xl={2} lg={2} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Middle Initial")}</Typography>
                            <TextField
                                {...register('miiddlename', { required: false, pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="miiddlename"
                                sx={textboxCss}
                                value={userDetails?.middleName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "middle name" }}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Last Name")} <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('lastname', { required: true, pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="lastname"
                                sx={textboxCss}
                                value={userDetails?.lastName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "last name" }}
                            />
                        </div>
                        {errors?.lastname?.type === "required" && <span style={ErrorStyle}>Please enter last name.</span>}
                        {errors?.lastname?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Language")} <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                margin="normal"
                                id="language"
                                sx={textboxCss}
                                value={langs[userDetails?.langPreference] || langs["en"]}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "last name" }}
                            />
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Admin User")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isAdminUser"
                                control={control}
                                rules={{ required: 'Please select an option' }} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio',userDetails?.roleId === 201 ? "yes" : "no"].join(' ')}
                                        value={userDetails?.roleId === 201 ? 'Yes' : "No"}
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => field.onChange(value)}
                                    />
                                    {errors.isAdminUser && <span style={ErrorStyle}>{errors.isAdminUser.message}</span>}
                                    </>
                                )}
                                />
                            </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Active")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isActive"
                                control={control}
                                rules={{ required: 'Please select an option' }} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio', userDetails?.isActive === true ? "yes" : "no"].join(' ')}
                                        value={userDetails?.isActive ? 'Yes' : "No"}
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => field.onChange(value)}
                                    />
                                    {errors.isActive && <span style={ErrorStyle}>{errors.isActive.message}</span>}
                                    </>
                                )}
                                />
                        </div>
                        {errors?.name?.type === "required" && <span style={ErrorStyle}>Please choose the options.</span>}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Select your Locations")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                        <BusinessUnitLocationMapping dataObj={isAdminUser} businessOption={businessOption} selectedItems={selectedItems} setSelectedItems={setSelectedItems} bunitFilterList={filterData} isDisabled={true} />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item  md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Styled.CancelButton
                            variant="outlined"
                            sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                            color="primary"
                            className="xxs-bold"
                            onClick={() => navigate('/user-management')}
                        >
                            {t("Cancel")}
                        </Styled.CancelButton>
                    </Grid>
                </Grid>
            </form>
    </div >
}

ViewUser.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
    };
}
const mapStateToProps = (state) => ({ 
 })


export default connect(mapStateToProps, mapDispatchToProps)(ViewUser);